import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import HistoryIcon from '@mui/icons-material/History';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import UpdateIcon from '@mui/icons-material/Update';
import MDBox from 'components/MDBox';
import DashboardNavbar from '../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../LayoutContainers/DashboardLayout';
import AdminCenterCard from './AdminCenterCard';

const adminCenterCards = [
  {
    icon: <GroupsIcon sx={{ color: '#0b7fad' }} />,
    title: 'Permissions',
    info: 'Manage access levels and user roles. Configure fine-grained security policies and department-level hierarchies.',
    navigationItems: [
      {
        text: 'Device Permissions',
        to: '/manage-permissions/devices',
      },
      {
        text: 'User Permissions',
        to: '/manage-permissions/users',
      },
    ],
  },
  {
    icon: <SensorsOffIcon sx={{ color: '#d43f51' }} />,
    title: 'Sensor Monitoring',
    info: 'Access the Inactive Sensors report. Track sensor uptime and inactivity patterns to ensure hardware reliability.',
    navigateText: 'View Reports',
    navigateTo: '/inactive-devices-report',
  },
  {
    icon: <HistoryIcon sx={{ color: '#1b2c48' }} />,
    title: 'System Logs',
    info: 'View Controller Set Point history. Audit log of set point changes, maintenance interventions, and logic overrides.',
    navigateText: 'Audit History',
    navigateTo: '/device-set-point-history/',
  },
  {
    icon: <QueryStatsIcon sx={{ color: '#24835d' }} />,
    title: 'Statistics',
    info: 'Review device uptime, customer activity, and operational performance trends across selected time periods.',
    navigateText: 'View Statistics',
    navigateTo: '/statistics/',
  },
  {
    icon: <UpdateIcon sx={{ color: '#b5651d' }} />,
    title: 'Immediate Updates',
    info: 'Select devices and start their Solin updater now.',
    navigateText: 'Start Now',
    navigateTo: '/solin-updater-trigger/',
  },
];

export const AdminCenter = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar objectName="Admin Center" />
      <Typography
        fontSize="11px"
        sx={{
          paddingLeft: { xs: 0, sm: '12px' },
          marginTop: { xs: '-15px', sm: '-5px' },
          textAlign: { xs: 'center', sm: 'left' },
        }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox
        sx={{
          backgroundColor: '#eff0ff',
          borderRadius: '8px',
          mt: 3,
          p: { xs: 2, md: 0 },
        }}>
        <Grid container spacing={3}>
          {adminCenterCards.map(card => (
            <Grid item xs={12} md={4} key={card.title} sx={{ display: 'flex' }}>
              <AdminCenterCard
                icon={card.icon}
                title={card.title}
                info={card.info}
                navigateText={card.navigateText}
                navigateTo={card.navigateTo}
                navigationItems={card.navigationItems}
              />
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default AdminCenter;
